import { browserHistory } from 'react-router';
import {
  SSO_API_URL,
  APP_VERSION,
  API_VERSION,
  API_VERSION_V3
} from '../common/config';
import { store } from '../redux/store';
import { loaderSet, notifySet } from '../redux/actions';
// eslint-disable-next-line import/no-cycle
import {
  getServerUrl,
  queryString,
  queryArray,
  getAuthToken,
  getUserId,
  getSelectedTeamName,
  convertFormData,
  getAPIUrl,
  getFirstLoginToken,
  storeFirstLoginToken,
  getUserLoginPayload
} from '../common/globals';
import { requestForToken } from '../helpers/firebase.js';

let sessionExpireMessageModal = null;
let internalServerErrorModal = null;
let remoteWipeModal = null;
let statusCode400Modal = null;
let statusCode426Modal = null;
let statusCode503Modal = null;
let acmPushCaseStatusCodeModal = null;

let signal = null;

const validateResponse = async (response, apiname) => {
  const apiRes = await response.json();
  const jsonResponse = {
    ...apiRes,
    status: false
  };

  if (response.status === 401) {
    // Open pop-up
    sessionExpireMessageModal = new window.bootstrap.Modal(window.$('#sessionExpireMessageModal'));
    sessionExpireMessageModal.show();
    jsonResponse.status = false;
    return jsonResponse;
  }

  if (response.status === 451) {
    remoteWipeModal = new window.bootstrap.Modal(window.$('#remoteWipeModal'));
    remoteWipeModal.show();
    jsonResponse.status = false;
    jsonResponse.message = '';
    return jsonResponse;
  }

  if (response.status === 400) {
    if (typeof apiname !== 'undefined') {
      // Open pop-up
      acmPushCaseStatusCodeModal = new window.bootstrap.Modal(window.$('#acmPushCaseStatusCodeModal'));
      if (jsonResponse.message) {
        const acmPushCaseStatusCodeModalMessage = document.querySelector('#acmPushCaseStatusCodeModal-message');
        acmPushCaseStatusCodeModalMessage.innerHTML = jsonResponse.message.replace('/r/n', '<br />');
      }

      acmPushCaseStatusCodeModal.show();
      jsonResponse.status = false;
      return jsonResponse;
    }

    store.dispatch(notifySet({
      type: 'error',
      message: response.message ? response.message : apiRes.message
    }));
  }

  if (response.status === 403 || response.status === 404) {
    store.dispatch(notifySet({
      type: 'error',
      message: response.message
    }));
    browserHistory.push('/team');
  }

  if (response.status === 404) {
    // store.dispatch(notifySet({
    //   type: 'error',
    //   message: response.message
    // }));
  }

  if (response.status === 426) {
    // Open pop-up
    statusCode426Modal = new window.bootstrap.Modal(window.$('#statusCode426Modal'));
    statusCode426Modal.show();
    jsonResponse.status = false;
    return jsonResponse;
  }

  if (response.status === 500) {
    // Open pop-up
    internalServerErrorModal = new window.bootstrap.Modal(window.$('#internalServerErrorModal'));
    internalServerErrorModal.show();
    jsonResponse.status = false;
    return jsonResponse;
  }

  if (response.status === 503) {
    // Open pop-up
    statusCode503Modal = new window.bootstrap.Modal(window.$('#statusCode503Modal'));
    if (jsonResponse.message) {
      const statusCode503ModalMessage = document.querySelector('#statusCode503Modal-message');
      statusCode503ModalMessage.innerHTML = jsonResponse.message;
    }
    statusCode503Modal.show();
    jsonResponse.status = false;
    return jsonResponse;
  }

  if (response.status === 200 || response.status === 204) {
    jsonResponse.status = true;
  } else {
    jsonResponse.status = false;
  }

  return jsonResponse;
};

const validateAuthResponse = async (response) => {
  const apiRes = await response.json();
  const jsonResponse = {
    ...apiRes,
    status: false
  };

  if (response.status === 400) {
    if (jsonResponse.message === 'Please upgrade your app version. It\'s out of date.') {
      // Open pop-up
      statusCode400Modal = new window.bootstrap.Modal(window.$('#statusCode400Modal'));
      statusCode400Modal.show();
      jsonResponse.status = false;
      return jsonResponse;
    }
  }

  if (response.status === 503) {
    return jsonResponse;
  }

  if (response.status === 200 || response.status === 204) {
    jsonResponse.status = true;
  } else {
    jsonResponse.status = false;
  }
  return jsonResponse;
};

const handleNetworkError = async (responseError) => {
  if (responseError.name !== 'AbortError') {
    store.dispatch(loaderSet(false));
    store.dispatch(notifySet({
      type: 'error',
      message: 'Network request error. Please try again.'
    }));
  }
};

export const initAPIController = () => {
  const controller = new AbortController();
  signal = controller.signal;
  return controller;
};

export const login = (data) => fetch(`${SSO_API_URL}/auth/login`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateAuthResponse(response))
  .catch((error) => handleNetworkError(error));

export const forgotPassword = (data) => fetch(`${SSO_API_URL}/auth/send_reset_password`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateAuthResponse(response))
  .catch((error) => handleNetworkError(error));

export const changePassword = (data) => fetch(`${SSO_API_URL}/auth/change_password`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateAuthResponse(response))
  .catch((error) => handleNetworkError(error));

export const reLogin = async (data) => fetch(`${await getServerUrl()}/api/auth/login`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const syncData = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/sync?${queryString(data)}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const listCases = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/listCases?${queryString(data)}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const addCases = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/cases`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getBillingCounts = async () => fetch(`${await getAPIUrl()}/api/${API_VERSION}/getBillingCounts`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const searchCases = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/searchCases?${queryString(data.string)}&${queryArray(data.array)}`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getSetProducts = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/setProducts?${queryString(data)}`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const caseDgrsList = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseDgrs/${data}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const uploadDgr = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseDgrs`, {
  method: 'POST',
  headers: {
    Accept: 'application/x-www-form-urlencoded',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: await convertFormData(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const removeDgr = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseDgrs/${data}`, {
  method: 'DELETE',
  headers: {
    Accept: 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const generateTimedURL = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/generateUrl?${queryString(data)}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const searchSets = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/searchSets?${queryString(data)}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const updateSetsStatus = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/setStatus?`, {
  method: 'POST',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken(),
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getLocations = async () => fetch(`${await getAPIUrl()}/api/${API_VERSION}/setLocations?`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getSetMoveLocations = async () => fetch(`${await getAPIUrl()}/api/${API_VERSION}/setMoveLocations?`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getBackorders = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/backorders?${queryArray(data)}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getBackordersCaseTypes = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/backordersCaseTypes?${queryArray(data)}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getBackordersAccounts = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/backordersAccounts?${queryArray(data)}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getBackordersProducts = async (data, dataString) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/backordersProducts?${queryArray(data)}&${queryString(dataString)}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getShipments = async (data, location) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/shipments?${location ? `shipFromLoc=${location}&` : ''}${queryArray(data)}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getShipmentsShipTo = async (data, location) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/shipmentsShipsTo?${location ? `shipFromLoc=${location}&` : ''}${queryArray(data)}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getShipmentsShipDates = async (data, location) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/shipmentsShipsDate?${location ? `shipFromLoc=${location}&` : ''}${queryArray(data)}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getShipmentsCaseDates = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/shipmentsCasesDate?${queryArray(data)}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getShipmentsProducts = async (data, location) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/shipmentsProducts?${location ? `shipFromLoc=${location}&` : ''}${queryArray(data.arrayParams)}&${queryString(data.stringParams)}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getShipmentTracking = async (trackingNumber, provider) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/shipmentsTracking?trackingNumber=${trackingNumber}&provider=${provider}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const caseXraysList = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseXrays/${data}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const uploadXray = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseXrays`, {
  method: 'POST',
  headers: {
    Accept: 'application/x-www-form-urlencoded',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: await convertFormData(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const removeXray = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseXrays/${data}`, {
  method: 'DELETE',
  headers: {
    Accept: 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const searchBilled = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/getCaseReport?${data}`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const cancelCase = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/cases/${data}`, {
  method: 'DELETE',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const removePreference = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/preferences/${data}`, {
  method: 'DELETE',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const updateCase = async (data) => {
  if (!data.selectedSets) {
    if (data.case_sets !== undefined) {
      const newArrayOfObj = data.case_sets.map(({
        CasePlanId: CasePlanID,
        ...rest
      }) => ({
        CasePlanID,
        ...rest
      }));
      data.selectedSets = newArrayOfObj;
    }
  }

  return fetch(`${await getAPIUrl()}/api/${API_VERSION}/cases/${data.CaseScheduleID}`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      requestSource: 'WEBSITE',
      'app-version': APP_VERSION,
      Team: await getSelectedTeamName(),
      Caller: await getUserId(),
      Authorization: await getAuthToken()
    },
    body: JSON.stringify(data)
  }).then(async (response) => await validateResponse(response))
    .catch((error) => handleNetworkError(error));
};

export const caseBillingDetails = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseBilling/${data}`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getSetContents = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/searchSets?${queryString(data)}`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const editPreference = async (name, data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/preferences/${name}`, {
  method: 'PUT',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const addPreference = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/preferences`, {
  method: 'POST',
  headers: {
    Accept: 'application/x-www-form-urlencoded',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: await convertFormData(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const listSingleCase = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/cases/${data}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const signout = async () => {
  const loginPayLoad = await getUserLoginPayload();
  let deviceToken = await requestForToken();
  if (typeof loginPayLoad !== 'undefined' && loginPayLoad !== null && typeof loginPayLoad.deviceId !== 'undefined' && loginPayLoad.deviceId !== null) {
    deviceToken = loginPayLoad.deviceId;
  }

  return fetch(`${SSO_API_URL}/auth/logout?deviceToken=${deviceToken}`, {
    method: 'GET',
    headers: {
      'x-access-token': getFirstLoginToken()
    },
  }).then(async (response) => {
    storeFirstLoginToken('');
    return await validateAuthResponse(response);
  }).catch((error) => handleNetworkError(error));
};

export const addProduct = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseProducts`, {
  method: 'POST',
  headers: {
    Accept: 'application/x-www-form-urlencoded',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: await convertFormData(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getCasesProducts = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseProducts?${queryString(data)}`, {
  method: 'GET',
  signal,
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const updateProduct = async (id, data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseProducts/${id}`, {
  method: 'PUT',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const removeProduct = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseProducts/${data}`, {
  method: 'DELETE',
  headers: {
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const updateACMProduct = async (id, data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseProductsAcm/${id}`, {
  method: 'PUT',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getPreferences = async () => fetch(`${await getAPIUrl()}/api/${API_VERSION}/preferences`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getNewRepReports = async () => fetch(`${await getAPIUrl()}/api/${API_VERSION}/getRepReports`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getSetProductContents = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/setProducts?${queryString(data)}`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const searchBilledCase = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/getCaseReport?${queryString(data)}`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getInventoryData = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/inventory?${queryString(data)}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const saveScanInventoryData = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/inventory`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const submitScanData = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/inventory`, {
  method: 'PUT',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const updateUsersSettings = async (data, getSettingsPayload) => fetch(`${SSO_API_URL}/users/edit/${getSettingsPayload.userId}`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-access-token': getSettingsPayload.sessionToken
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateAuthResponse(response))
  .catch((error) => handleNetworkError(error));

export const getUsersSettings = async (getSettingsPayload) => fetch(`${SSO_API_URL}/users/${getSettingsPayload.userId}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-access-token': getSettingsPayload.sessionToken
  },
}).then(async (response) => await validateAuthResponse(response))
  .catch((error) => handleNetworkError(error));

export const addComplianceAppData = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseVhnCompliance`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const addDersDetails = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/Ders`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const searchDers = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/Ders?${queryString(data)}`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    'Content-Type': 'application/json',
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const updateDers = async (id, data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/Ders/${id}`, {
  method: 'PUT',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const generateBulkTimedURL = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/generateUrlBulk?${queryString(data)}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getCaseSetAggregate = async (selectedDate, customerNo) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseSetsAggregate/${selectedDate}/${customerNo}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const searchToObject = (search) => {
  const pairs = search.substring(1).split('&');
  const obj = {};
  pairs.forEach((pair) => {
    if (pair === '') return;
    const key = pair.split('=')[0];
    const value = pair.split('=')[1];
    obj[key] = value;
  });
  return obj;
};

export const getNotifications = async (data) => fetch(`${SSO_API_URL}/push/notifications?${queryString(data)}`, {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'x-access-token': getFirstLoginToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const patchNotifications = async (id) => fetch(`${SSO_API_URL}/push/notifications${id ? `/${id}` : ''}`, {
  method: 'PATCH',
  headers: {
    'Content-Type': 'application/json',
    'x-access-token': getFirstLoginToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getSales = async (groupBy, data = null, CM = '') => fetch(`${await getAPIUrl()}/api/${API_VERSION}/sales?GroupBy=${groupBy}${CM ? `&CM=${CM}` : ''}&${data ? queryArray(data) : ''}`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    'Content-Type': 'application/json',
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getApplicableDepuyMonths = async () => fetch(`${await getAPIUrl()}/api/${API_VERSION}/sales/depuyMonths`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    'Content-Type': 'application/json',
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const caseHistory = async (id, data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/caseHistory/${id}?${queryString(data)}`, {
  method: 'GET',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    'Content-Type': 'application/json',
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getUsersData = async (getSettingsPayload) => fetch(`${getSettingsPayload.url}/api/users/${getSettingsPayload.userId}?requestSource=website`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-access-token': getSettingsPayload.sessionToken
  },
}).then(async (response) => await validateAuthResponse(response))
  .catch((error) => handleNetworkError(error));

export const updateACMLog = async (ACMCaseID, data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/supply-chain/cases/${ACMCaseID}`, {
  method: 'PUT',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getSurgeonNotes = async () => fetch(`${await getAPIUrl()}/api/${API_VERSION}/surgeonNotes?search_term=`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getSurgeonNotesList = async () => fetch(`${await getAPIUrl()}/api/${API_VERSION}/surgeonNotes`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const addSurgeonNotes = async (data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/surgeonNotes`, {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const editSurgeonNotes = async (id, data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/surgeonNotes/${id}`, {
  method: 'PUT',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const removeSurgeonNotes = async (id) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/surgeonNotes/${id}`, {
  method: 'DELETE',
  headers: {
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  }
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const updatePushToACM = async (CaseScheduleID, data) => fetch(`${await getAPIUrl()}/api/${API_VERSION}/cases/pushToAcm/${CaseScheduleID}`, {
  method: 'PUT',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
  body: JSON.stringify(data)
}).then(async (response) => await validateResponse(response, 'PUSHACM'))
  .catch((error) => handleNetworkError(error));

export const getCaseSetAggregateV3 = async (selectedDate, customerNo) => fetch(`${await getAPIUrl()}/api/${API_VERSION_V3}/caseSetsAggregate/${selectedDate}/${customerNo}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));

export const getCaseProductItems = async (CaseScheduleID) => fetch(`${await getAPIUrl()}/api/${API_VERSION_V3}/caseProductItems/${CaseScheduleID}`, {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    requestSource: 'WEBSITE',
    'app-version': APP_VERSION,
    Team: await getSelectedTeamName(),
    Caller: await getUserId(),
    Authorization: await getAuthToken()
  },
}).then(async (response) => await validateResponse(response))
  .catch((error) => handleNetworkError(error));
